export const config = {
    apiUrl: '/'
};